import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Modal, Paper, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import classnames from "classnames";
import { useState } from "react";
import { ServingAmountViewChipList } from "../../ServingAmount/View/ChipList";
const useStyles = makeStyles((theme) => createStyles({
    root: {
        margin: theme.spacing(2),
        height: `calc(100% - ${theme.spacing(4)})`,
        background: "white",
        display: "flex",
        flexDirection: "column",
    },
    contentRoot: {
        boxSizing: "border-box",
    },
    contentRootWithFooter: {
        paddingBottom: 0,
    },
    spacer: {
        flexGrow: theme.spacing(),
    },
    header: {
        marginTop: theme.spacing(-0.5),
        gridColumnStart: 1,
        gridRowStart: 1,
        overflow: "hidden",
    },
    note: {
        marginTop: theme.spacing(),
        color: theme.palette.text.secondary,
    },
    chipListOuter: {
        overflowY: "hidden",
        gridColumnStart: 1,
        gridRowStart: 2,
    },
    chipListInner: {},
    seeMoreTypography: {
        color: "blue",
        textAlign: "center",
        width: "100%",
        textDecoration: "underline",
        cursor: "pointer",
        marginBottom: theme.spacing(-1.5),
    },
    modal: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    paper: {
        padding: theme.spacing(2),
        maxHeight: "75%",
        width: "75%",
        overflowY: "scroll",
    },
}));
export const MealOptionView = ({ targets, mealOption, footer, className }) => {
    const classes = useStyles();
    const [outerEl, setOuterEl] = useState(null);
    const [innerEl, setInnerEl] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const outerHeight = outerEl !== null ? outerEl.getBoundingClientRect().height : 0;
    const innerHeight = innerEl !== null ? innerEl.getBoundingClientRect().height : 0;
    const { servingAmounts } = mealOption;
    const servingChipsComponent = _jsx(ServingAmountViewChipList, { servingAmounts: servingAmounts, hideLimitedAccessWarning: true });
    return (_jsxs(Card, { className: classnames(classes.root, className), raised: true, children: [_jsxs(CardContent, { classes: {
                    root: classnames(classes.contentRoot, footer && classes.contentRootWithFooter),
                }, children: [(targets || mealOption.note) && (_jsxs("div", { className: classes.header, children: [targets, _jsx("div", { className: classes.note, children: _jsx(Typography, { variant: "subtitle1", children: mealOption.note }) })] })), _jsx("div", { className: classes.chipListOuter, ref: ref => setOuterEl(ref), children: _jsx("div", { className: classes.chipListInner, ref: ref => setInnerEl(ref), children: servingChipsComponent }) }), outerHeight < innerHeight && (_jsx(Typography, { className: classes.seeMoreTypography, onClick: () => setModalOpen(true), variant: "body2", children: "See All" })), modalOpen && (_jsx(Modal, { open: modalOpen, onClose: () => setModalOpen(false), className: classes.modal, children: _jsx(Paper, { className: classes.paper, children: servingChipsComponent }) }))] }), _jsx("div", { className: classes.spacer }), footer] }));
};
//# sourceMappingURL=index.js.map